import fetch from "auth/FetchInterceptor";
import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_REFRESH,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  AUTH_WHOAMI,
} from "constants/ApiConstant";

const AuthService = {};

AuthService.login = function (data) {
  return fetch({
    url: AUTH_LOGIN,
    method: "post",
    data: data,
  });
};

AuthService.logout = function () {
  return fetch({
    url: AUTH_LOGOUT,
    method: "post",
  });
};

AuthService.forgotPassword = function (data) {
  return fetch({
    url: FORGOT_PASSWORD,
    method: "post",
    data: data,
  });
};

AuthService.refreshToken = function () {
  return fetch({
    url: AUTH_REFRESH,
    method: "post",
  });
};

AuthService.resetPassword = function (data) {
  return fetch({
    url: RESET_PASSWORD,
    method: "post",
    data: data,
  });
};

AuthService.whoami = function () {
  return fetch({
    url: AUTH_WHOAMI,
    method: "get",
  });
};

export default AuthService;
